const customDropzoneStyles = {
  dropzone: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    border: "2px dashed",
    borderColor: "neutral.300",
    textAlign: "center",
    transition: "border-color 0.3s",
    borderRadius: "26px",
  },
  dragover: {
    border: "2px dashed",
    borderColor: "primary.main",
    backgroundColor: "primary.alpha8",
  },
  dropzoneText: {
    color: "text.secondary",
    // fontSize: "1.25rem",
    fontWeight: 500,
  },
  acceptedFilesText: {
    color: "text.secondary",
    // fontSize: "0.775rem",
    fontWeight: 500,
    textAlign: "center",
  },
  greyBox: {
    margin: "1%",
  },
};

export default customDropzoneStyles;
